import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Release filebox record DTO
 */
export class ReleaseFileboxRecordDto {
	synchronizationToken!: string;
	@TransformDate()
	synchronizedAt?: Date;
	synchronizationError?: string;
}
